const Events = {
  UPDATE_WORKSPACE_INVESTIGATIONS: 'UpdateInvestigations',
  LOAD_COMPLETE: 'LoadComplete'
};

export default Events;